// src/components/Admin/StoreManager/index.jsx
import { Tabs, Tab, Box, Typography, Paper } from '@mui/material';
import { useState } from 'react';
import EmoticonManager from '../EmoticonManager';
import ItemManager from '../ItemManager';
import MiniroomManager from '../MiniroomManager';

// 아이콘
import StorefrontIcon from '@mui/icons-material/Storefront';
import CardGiftcardIcon from '@mui/icons-material/CardGiftcard';
import EmojiEmotionsIcon from '@mui/icons-material/EmojiEmotions';
import ChairIcon from '@mui/icons-material/Chair';   // 🪑 가구 아이콘

const StoreManager = () => {
    const [tab, setTab] = useState(0);

    return (
        <Box
            sx={{
                p: 4,
                /* 모바일: 90 % 축소 & 좌상단 기준 */
                '@media (max-width:600px)': {
                    transform: 'scale(0.9)',
                    transformOrigin: 'top left',
                    p: 2,
                },
            }}
        >
            {/* 타이틀 */}
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 3 }}>
                <StorefrontIcon sx={{ fontSize: '2rem' }} />
                <Typography
                    variant="h4"
                    sx={{
                        fontWeight: 'bold',
                        '@media (max-width:600px)': { fontSize: '1.5rem' },
                    }}
                >
                    상점 관리
                </Typography>
            </Box>

            {/* 탭 메뉴 */}
            <Paper
                elevation={2}
                sx={{
                    mb: 3,
                    borderRadius: 2,
                    backgroundColor: '#f5f5f5',
                    px: 2,
                    '@media (max-width:600px)': { px: 1 },
                }}
            >
                <Tabs
                    value={tab}
                    onChange={(_, v) => setTab(v)}
                    textColor="primary"
                    indicatorColor="primary"
                    variant="fullWidth"
                    sx={{
                        '& .MuiTab-root': {
                            minHeight: 48,
                            '@media (max-width:600px)': { minHeight: 40, fontSize: '0.8rem' },
                        },
                    }}
                >
                    <Tab icon={<CardGiftcardIcon />} iconPosition="start" label="쿠폰 관리" />
                    <Tab icon={<EmojiEmotionsIcon />} iconPosition="start" label="이모티콘 관리" />
                    <Tab icon={<ChairIcon />} iconPosition="start" label="미니룸 가구 관리" />
                </Tabs>
            </Paper>

            {/* 콘텐츠 */}
            {tab === 0 && <ItemManager />}
            {tab === 1 && <EmoticonManager />}
            {tab === 2 && <MiniroomManager />}
        </Box>
    );
};

export default StoreManager;
